import { Color } from "three"
import _ from "lodash"
import TWEEN from "@tweenjs/tween.js"

import { BaseObject } from "maptalks.three"
import { Billboard } from "../object3d"

export const createHighlightBillboardController = (obj: Billboard) => {
  const controller = { start: () => {}, clear: () => {} }
  if (!(obj instanceof Billboard)) return controller

  const { altitude, altitudeFactor } = obj.properties.default

  if (altitude !== 0) {
    const newAltitude = _.clamp(altitude * altitudeFactor, 0, altitude)
    const tween = new TWEEN.Tween({ altitude })
      .to({ altitude: newAltitude }, 800)
      .easing(TWEEN.Easing.Quartic.Out)
      .onUpdate((newUpdate) => {
        obj.setLineHeight(newUpdate.altitude)
      })

    controller.start = () => {
      tween.start()
    }

    controller.clear = () => {
      tween.stop().to({ altitude }, 1600).startFromCurrentValues()
    }
  }

  return controller
}

export const createHighlightExtrudeObjectController = (
  obj: BaseObject,
  { color }
) => {
  const controller = { start: () => {}, clear: () => {} }
  if (
    obj?.type !== "ExtrudePolygon" ||
    _.isNil(obj?.object3d?.material?.color) ||
    _.isNil(color)
  )
    return controller
  controller.start = () => {
    obj.object3d.material.color = new Color(color)
  }

  controller.clear = () => {
    const objectDefaultColor = _.get(obj, "properties.defaultColor")
    obj.object3d.material.color = new Color(objectDefaultColor)
  }

  return controller
}

export const createHighlightSectionVisibilityController = (obj: BaseObject) => {
  const controller = { start: () => {}, clear: () => {} }

  if (
    (obj?.type !== "ExtrudePolygon" && obj?.type !== "FatLines") ||
    _.isNil(obj?.object3d?.material)
  )
    return controller

  controller.start = () => {
    const objectOpacity = _.get(obj, "properties.opacity")

    obj.object3d.material.visible = true
    obj.object3d.material.opacity = objectOpacity
  }

  controller.clear = () => {
    const objectOpacity = _.get(obj, "properties.opacity")

    obj.object3d.material.visible = false
    obj.object3d.material.opacity = objectOpacity
  }

  return controller
}
